import * as React from 'react';
import { Button } from '../../Button';

type IOpenButtonProps = {
    render?: (onClick: (event?: React.MouseEvent) => void) => React.ReactNode;
    onClick: (event?: React.MouseEvent) => void;
    value?: React.ReactNode;
    name?: string;
};

export const DialogOpenButton = ({ name = '', render, value, ...rest }: React.PropsWithChildren<IOpenButtonProps>) => {
    const openButton =
        render ||
        function (onClick: (event: React.MouseEvent) => void) {
            return (
                <Button {...rest} name={name || ''} onClick={onClick} variant="contained" data-testid="openButton">
                    {value}
                </Button>
            );
        };

    return <React.Fragment>{openButton(rest.onClick)}</React.Fragment>;
};
